export default __webpack_public_path__ + "static/media/land.77742840.svg";